<template>
    <div class="tab main-tab text-unselect" :class="['tab-container', { 'hidden': isHidden }]">
        <div class="left phone" @click="goHome()">
            <div class="top-left-div"></div>
            <div class="btm-right-div"></div>
            <!-- <div class="btm-right-div">NOW OPEN FOR E-APPLICATION</div> -->
            <!-- <div class="btm-right-div"></div> -->
        </div>
        <div class="logo" @click="gopage('/')">
            <img class="img-contain" src="@/assets/logo1.png" alt="">
        </div>
        <div class="right">
            <div class="btn phone">
                <span @click="downloadFile()">VIEW E-BROCHURE</span>
                <span class="m-l-5 m-r-5">|</span>
                <span @click="goHome()">CONTACT US</span>
            </div>
            <div @click="isPopVisible = !isPopVisible" class="btn1 cursor-pointer">
                <img style="width: 30px;" v-if="!isPopVisible" src="@/assets/btn/tab-btn.png" alt="">
                <span v-else >X</span>
            </div>
        </div>
        <div v-if="isPopVisible" class="popList bg-666b50 flex flex-center flex-column" data-aos="fade-btm" data-aos-duration="100">
            <div @click="gopage(item.path)" :class="{'nowtab':$route.path == item.path}" class="popItem m-b-10" v-for="(item, index) in tabList" :key="index">
                    {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tab',
    data() {
        return {
            isPopVisible: false,
            isHidden: false,
            lastScrollTop: 0,
            tabList:[
                { name: 'HOME', path: '/' },
                { name: 'LOCATION', path: '/location' },
                { name: 'FACILITIES', path: '/facilities' },
                { name: 'INTERIOR', path: '/interior' },
                { name: 'GALLERY', path: '/gallery' },
                { name: 'EC ELIGIBILITY', path: '/Eligibility-Booklet' },
                { name: 'ABOUT US', path: '/developers' },
            ],
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        downloadFile() { 
           let url = 'https://mixgovr.com/WEB/OTTO-New/OTTO_Brochure_Spreads_LR.pdf'
           window.open(url)
        },
        isPhone(){
        // 检测是否是手机
        let ua = navigator.userAgent;
        let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        if (isMobile) {
          // 如果是手机，显示手机相关内容
          this.$refs.Contact.classList.add("phone-none");
        } else {
          // 如果不是手机，隐藏手机相关内容
          this.$refs.Contact.classList.remove("phone-none");
        }
      },
      goHome() {
        this.$router.push('/')

        // 延时1秒
        // setTimeout(() => {
        //   this.$router.push('/')
        // }, 1000);

        const checkElement = setInterval(() => {
        const contant = document.querySelector('.Contact');
            if (contant) {
                console.log('元素已检测到:', contant);
                window.scrollTo({
                    top: document.documentElement.scrollHeight - 1100,
                    behavior: 'smooth',
                });
                clearInterval(checkElement); // 停止检测
            }
        }, 500); // 每 100ms 检测一次

        // this.$nextTick(() => {
        // const contant = document.querySelector('.Contact');
        // console.log(contant);
        // // 可能会存在页面加载时滚动位置不正确的情况
        // window.scrollTo(
        //     {
        //         top: document.documentElement.scrollHeight - 1100, // 滚动到的位置
        //         behavior: 'smooth' // 平滑滚动效果
        //     }
        // );
        // });
      },
        gopage(path) { 
            this.$router.push(path)
            this.isPopVisible = false
            // 初始化滚动距离

            window.scrollTo(0, this.scrollTop)
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop
            this.isHidden = currentScrollTop > this.lastScrollTop && currentScrollTop > 50
            if (this.isHidden) {
                this.isPopVisible = false // 隐藏弹出菜单
            }
            this.lastScrollTop = currentScrollTop
        }
    }
}
</script>

<style lang="less" scoped>
.tab-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    transition: transform 0.3s ease;
}

.tab{
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    color: #fff;
    background-color: #3e4037;
    border-bottom: 4px solid #666b50;
    .left{
    display: flex;
    flex-direction: row;
    .top-left-div{
        border-bottom: 4px solid #666b50;
        border-right: 4px solid #666b50;
        width: 60px;
        height: 60px;
    }
    .btm-right-div{
        border-bottom: 4px solid #666b50;
        border-left: 4px solid #666b50;
        margin-left: -4px;
        width: 252px;
        height: 50px;
        font-size: 1rem;
        text-align: start;
        padding-left: 10px;
        padding-bottom: 10px;
        display: flex;
        align-items: flex-end;
    }
    }

    .right{
    display: flex;
    align-items: center;
    .btn1{
        width: 15px;
        margin-right: 45px;
        margin-left: 10px;
        font-size: 26px;
        color: white;
    }
    .btn{
        font-size: 14px;
        background-color: #666b50;
        padding: 10px 20px;
        position: relative;
        &::after{
        position: absolute;
        right: -85px;
        bottom: -30px;
        content: '';
        display: block;
        width: 85px;
        height: 30px;
        border-left: 4px solid #666b50;
        border-top: 4px solid #666b50;
        }
        &::before{
        position: absolute;
        left: 0;
        top: -60px;
        content: '';
        display: block;
        height: 60px;
        border-right: 4px solid #666b50;
        }
    }
    }
    .logo{
    width: 120px;
    }
    .popList{
        position: fixed;
        right: 69px;
        top: 31px;
        width: 260px;
        // height: 200px;
        border: 1px solid #666b50;
        padding: 20px 0;
        .nowtab{
            // 加粗的文本下划线
            font-weight: bold;
            text-decoration: underline;
            text-decoration-color: #3e4037;
            text-decoration-thickness: 4px;
            // 文字下划线和文字间距
            text-underline-offset: 5px;
            // margin-bottom: 5px;
            // border-bottom: 2px solid #666b50;
        }
        .popItem:hover{
            font-weight: bold;
        }

    }
    }

.hidden {
    transform: translateY(-100%);
}

@media screen and (max-width: 800px) {
    .logo{
        margin: 0 10px;
    }
    .right{
        z-index: 999;
    }
    .popList{
        width: 100% !important;
        height: 100% !important;
        left: 0 !important;
        top: 0!important;
        .nowtab{
            font-weight: 600;
        }
        .popItem{
            font-size: 22px;
        }
    }
}

</style>